import { render, staticRenderFns } from "./PulmoClass.vue?vue&type=template&id=4ffde480&"
import script from "./PulmoClass.vue?vue&type=script&lang=js&"
export * from "./PulmoClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports